const Desc = `documentOperations: Setting a layer visibility to false. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'files/_skycity_smoketest/adobe2s.psd',
            storage: 'adobe'
        }
    ],
    options: {
        layers: [
            {
                edit: {},
                id: -1,
                visible: false
            }
        ]
    },
    outputs: [
        {
            storage: 'adobe',
            type: 'image/png',
            overwrite: true,
            width: 0,
            compression: 'small'
        }
    ]
}

module.exports = { Payload, Desc }
